import React from 'react';
import { IconProps } from '../types';
const MinecraftWolfArmorOverlay: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="2" width="1" height="1" fill="rgba(205, 205, 205, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(214, 214, 214, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(210, 210, 210, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(201, 201, 201, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(214, 214, 214, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(205, 205, 205, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(195, 195, 195, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(214, 214, 214, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(205, 205, 205, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(195, 195, 195, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(214, 214, 214, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(201, 201, 201, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(191, 191, 191, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(205, 205, 205, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(201, 201, 201, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(184, 184, 184, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(205, 205, 205, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(201, 201, 201, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(191, 191, 191, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(205, 205, 205, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(201, 201, 201, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(184, 184, 184, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(205, 205, 205, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(184, 184, 184, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(201, 201, 201, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(201, 201, 201, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(195, 195, 195, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(195, 195, 195, 255)" />
</svg>);
export default MinecraftWolfArmorOverlay;